<template>
  <div id="app">
    <img alt="Vue logo" src="https://www.fabiuslela.com/favicon.ico">
    <SteerBar msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import SteerBar from './components/SteerBar.vue'

export default {
  name: 'app',
  components: {
    SteerBar
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
